<template>
  <div>
    <template v-for="(product, i) in productBlades">
      <blade-product
        :content="product"
        :alignment="product.align"
        :key="'product-blade-' + i"
        :imagePos="product.imagePos"
      ></blade-product>
    </template>
    <product-bucket :products="productList"></product-bucket>
  </div>
</template>

<script>
import BladeProduct from "@/components/blade-product";
import ProductBucket from "@/components/product-bucket";

export default {
  name: "headphones",
  components: { ProductBucket, BladeProduct },
  computed: {
    productBlades() {
      return this.$store.state.productsPage.productBlades;
    },
    productList() {
      return this.$store.state.productsPage.products;
    },
  },
};
</script>

<style scoped></style>
